import { getUserFromLS } from './getUserFromLS';
import {
  getPrimaryClientId,
  readStoredWorkspaceClientId,
  resolveEffectiveClientId,
} from './workspaceClientHelpers';

/**
 * Resolves the tenant client for orchestrator API calls.
 * Priority: explicit param → workspace session selection → primary from users/me.
 */
export function resolveTenantClientId(explicitClientId?: string | null): string | null {
  if (explicitClientId != null && explicitClientId !== '') {
    return String(explicitClientId);
  }
  const user = getUserFromLS();
  if (!user?.id) {
    return getPrimaryClientId(user);
  }
  const stored = readStoredWorkspaceClientId(user.id);
  return resolveEffectiveClientId(stored, user);
}
